import { useGetDetailOrders } from '@/hooks/order/useGetDetailOrders';
import { detailOrderToDetailOrderItemUi } from '@/hooks/order/useGetDetailOrders/mapper';
import { responseToPagingUi } from '@/hooks/pagingMapper';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useImmer } from 'use-immer';
import { OrdersDetaillUi, initialState } from './OrdersDetailUi';

export function useOrdersDetailViewController() {
  const [uiState, setUiState] = useImmer<OrdersDetaillUi>(initialState);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchParams, _] = useSearchParams();

  useEffect(() => {
    setCurrentPage(1);
  }, [searchParams]);

  const { data, isLoading } = useGetDetailOrders({
    page: currentPage,
  });

  useEffect(() => {
    setUiState((draft) => {
      draft.isLoading = isLoading;
      if (draft.isLoading) {
        draft.paging = undefined;
        draft.items = [];
      }
    });
  }, [isLoading]);

  useEffect(() => {
    if (!data) return;
    setUiState((prev) => {
      prev.paging = responseToPagingUi(data);
      prev.items = data.data?.map(detailOrderToDetailOrderItemUi) ?? [];
    });
  }, [data]);

  const onPageRequested = (page: number) => setCurrentPage(page);

  return {
    uiState,
    actions: {
      onPageRequested,
    },
  };
}
